import React from 'react';

const Tennant = () => {
  return (
    <div className="text-center">
      <h1 className="text-3xl font-bold mb-4">About Page</h1>
      <p>This is the about page of My App!</p>
    </div>
  );
};

export default Tennant;
